/**
 * Copyright (C) Sitevision 2002-2024, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-imageexplorer-portlet')) {
  import(
    /* webpackChunkName: "imageexplorer-portlet" */ '../util/static/selfserviceFieldset.css'
  );
}
